import * as React from 'react';

import LightningBolt16 from './LightningBolt16';

export const lightningBolt16 = () => <LightningBolt16 />;

export default {
    title: 'Icon/Fill/LightningBolt16',
    component: LightningBolt16,
    parameters: {
        notes: "`import LightningBolt16 from 'box-ui-elements/es/icon/fill/LightningBolt16';`",
    },
};
